export var QuestionContentElementTypes;
(function (QuestionContentElementTypes) {
    QuestionContentElementTypes["Image"] = "image";
    QuestionContentElementTypes["ImageWithRegions"] = "image-with-regions";
    QuestionContentElementTypes["ImageCompareSlider"] = "image-compare-slider";
})(QuestionContentElementTypes || (QuestionContentElementTypes = {}));
//# sourceMappingURL=question-content-element-types.types.js.map